import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-sage-50 to-white p-8">
      <div className="max-w-3xl mx-auto space-y-12">
        <section>
          <h1 className="text-3xl font-serif font-bold text-sage-800 mb-8 text-center">About Us</h1>
          <p className="font-serif text-lg leading-relaxed mb-6 text-justify">
            Welcome to Husband & Wife Devotional, a spiritual journey designed to strengthen marriages through daily devotions, prayers, and meaningful discussions.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-serif font-semibold text-sage-800 mb-6">How It Works</h2>
          <div className="grid gap-6">
            <Card className="p-6">
              <h3 className="text-xl font-serif font-semibold text-sage-800 mb-3">Daily Devotionals</h3>
              <p className="text-sage-700 leading-relaxed">
                Each day, we provide a carefully crafted devotional that includes a Bible passage, memory verse, 
                and an inspiring message focused on strengthening your marriage through faith.
              </p>
            </Card>

            <Card className="p-6">
              <h3 className="text-xl font-serif font-semibold text-sage-800 mb-3">Prayer Points</h3>
              <p className="text-sage-700 leading-relaxed">
                Morning and evening prayer points are provided to guide your daily spiritual journey together. 
                These prayers are specifically designed for couples to strengthen their bond through shared spiritual practice.
              </p>
            </Card>

            <Card className="p-6">
              <h3 className="text-xl font-serif font-semibold text-sage-800 mb-3">Spouse to Spouse</h3>
              <p className="text-sage-700 leading-relaxed">
                Each devotional includes a "Spouse to Spouse" section with discussion questions and reconciliation 
                prayers to foster meaningful conversations and strengthen your relationship.
              </p>
            </Card>
          </div>
        </section>

        <Separator className="my-8" />

        <section>
          <h2 className="text-2xl font-serif font-semibold text-sage-800 mb-6">Our Authors</h2>
          <Card className="p-8">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="w-full md:w-1/3">
                <img 
                  src="/lovable-uploads/16881c44-ddcb-4f72-a2c2-b9516059573c.png"
                  alt="Pastor Chidi and Pastor Mrs Nwamaka Nwulu"
                  className="rounded-lg shadow-lg w-full"
                />
              </div>
              <div className="w-full md:w-2/3">
                <h3 className="text-xl font-serif font-semibold text-sage-800 mb-4">
                  Pastor Chidi and Pastor Mrs Nwamaka Nwulu
                </h3>
                <p className="font-serif text-lg leading-relaxed text-justify text-sage-700">
                  Christian leaders and Church Administrators who were groomed at Christian Pentecostal Mission 
                  and Mountain of Fire and Miracles Ministries. They are marriage counselors whose heart beats 
                  with passion about Christ-centered families. Having been happily married for over 40 years, 
                  they bring a wealth of experience and wisdom to building Godly homes. Their journey together 
                  has been blessed with amazing children and wonderful grandchildren, and they are excited to 
                  share their insights about maintaining a Christ-centered marriage.
                </p>
              </div>
            </div>
          </Card>
        </section>

        <section>
          <h2 className="text-2xl font-serif font-semibold text-sage-800 mb-6">Our Mission</h2>
          <p className="font-serif text-lg leading-relaxed mb-6 text-justify text-sage-700">
            Our mission is to help couples grow together spiritually, fostering stronger marriages built on 
            faith, love, and mutual understanding. Through daily devotionals, guided prayers, and meaningful 
            discussions, we aim to strengthen the spiritual foundation of your marriage.
          </p>
        </section>
      </div>
    </div>
  );
};

export default About;